import React from 'react'
import { Radio } from 'antd'

import { OptionContent, OptionDescription, OptionTitle } from './styled'

interface TrainingTypeOptionProps {
  value: boolean
  title: string
  description: string
}

export const TrainingTypeOption: React.FC<TrainingTypeOptionProps> = ({
  value,
  title,
  description,
}) => (
  <Radio value={value}>
    <OptionContent>
      <OptionTitle>{title}</OptionTitle>
      <OptionDescription>{description}</OptionDescription>
    </OptionContent>
  </Radio>
)
